import { Link, useParams } from "react-router-dom";
import { UserUsageDetail } from "@/components/Settings/UserUsageDetail";

export function SettingsUsageUser() {
  const { appId, userId } = useParams<{ appId: string; userId: string }>();

  if (!appId || !userId) {
    return (
      <div className="p-6">
        <p className="text-sm text-red-700">Application ID and user ID are required.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6">
      <div>
        <div className="mb-2 text-sm text-muted-foreground">
          <Link to="/settings" className="hover:underline">
            Settings
          </Link>
          {" / "}
          <Link to="/settings/usage" className="hover:underline">
            Usage
          </Link>
          {" / "}
          <Link to={`/settings/usage/${appId}`} className="hover:underline">
            Application
          </Link>
        </div>
        <h1 className="text-3xl font-bold">User Activity</h1>
        <p className="mt-2 text-muted-foreground">
          Companies ingested, simulations run, and chat transcripts for this user.
        </p>
      </div>
      <UserUsageDetail appId={appId} userId={userId} />
    </div>
  );
}
